import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { makeGetDlpOrderValidationErrors } from 'state/secondaryMarket/dlpOrder/dlpOrder.selectors';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

export type DlpOrderStatus = 'NOT_READY' | 'READY' | 'ORDER_PENDING' | 'ORDER_PLACED' | 'ORDER_FAILED' | 'ORDER_STALE';

type StateProps = Readonly<{
  status: DlpOrderStatus;
}>;

export type SidePanelProps = OwnProps & StateProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getOrderValidationErrors = makeGetDlpOrderValidationErrors();
  const getOrderStatus = fromSecondaryMarket.dlpOrder.order.makeGetDlpOrderStatus(getOrderValidationErrors);

  return (state, { tabId }) => {
    const status = getOrderStatus(state, tabId);
    return {
      status,
    };
  };
};

export const connectSidePanel = connect(mapStateToProps);
